// Synchronous compatibility boundary for host-owned mutations that still call
// legacy hooks. This is deliberately not a sandbox for arbitrary plugin code.
let preparing = false;

export function isPreparingProjectMutation() { return preparing; }

export function prepareProjectMutation(callback) {
  if (preparing) throw new Error('Verschachtelte Projektvorbereitung ist nicht erlaubt.');
  preparing = true;
  try { return callback(); } finally { preparing = false; }
}
